import React, {useEffect} from 'react'
import {Grid} from '@mui/material'
import WbSwitch from '../../../components/common/WbSwitch'
import FormControlLabel from '@mui/material/FormControlLabel'
import {DateTimePicker} from '@mui/x-date-pickers'
import {DatePicker, LocalizationProvider, TimePicker} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'

export default function SelectDate({
  date,
  setDate,
  setSkipSchoolHolidays,
  skipSchoolHolidays,
}) {
  return (
    <>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Set Start Date</strong>
          </h3>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en-gb"
          >
            <DatePicker
              label="Select Date"

              onChange={newValue => setDate(newValue.format())}
              value={dayjs(date)}
            ></DatePicker>
          </LocalizationProvider>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={4}>
          <h3>
            <strong>Skip School Holiday</strong>
          </h3>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} mt={2} pl={1}>
          <FormControlLabel
            control={
              <WbSwitch
                size="small"
                checked={skipSchoolHolidays}
                onChange={e => setSkipSchoolHolidays(e.target.checked)}
              ></WbSwitch>
            }
            label="Skip to School Holiday"
          ></FormControlLabel>
        </Grid>
      </Grid>
    </>
  )
}
